import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initialize() {
    $('.page-tips select[name="category"]').on('change', function (evt) {
        if ($(this).val()) {
            window.location = '/dicas/' + $(this).val();
        }
    });
}

initialize();
